import UserManagementSection from "@/components/sections/UserManagementSection";

const Users = () => {
    return (
        <div className="container flex-1 flex-col flex-wrap items-center px-2 py-4 md:px-3 lg:px-4">
            <UserManagementSection />
        </div>
    );
};

export default Users;
